// extracted by mini-css-extract-plugin
module.exports = {"messagesContainer":"ChatMessages_messagesContainer__RKMHZ"};